/* Site-wide: brand placeholder, race data, the race ticker, and "your time".
   The visitor's time/name/race is kept in this browser (localStorage) so it
   follows them from page to page. Nothing is sent anywhere. */
(function () {
  // ---- The brand name. Every [data-brand] updates.
  var BRAND = "Race Posters";

  var RACES = [
    { slug: "auckland", title: "Auckland Marathon", city: "Tāmaki Makaurau", date: "2026-11-01", when: "Sun 1 Nov 2026",
      course: "Point to point, over the Harbour Bridge", distances: [["Marathon", 42.195], ["Half Marathon", 21.0975, "half"], ["11K Traverse", 11, "11k"]], themes: ["midnight", "paper"] },
    { slug: "queenstown", title: "Queenstown Marathon", city: "Tāhuna", date: "2026-11-14", when: "Sat 14 Nov 2026",
      course: "Point to point, Millbrook to the lakefront", distances: [["Marathon", 42.195], ["Half Marathon", 21.0975, "half"], ["10K", 10, "10k"]], themes: ["paper", "midnight"] },
    { slug: "christchurch", title: "Christchurch Marathon", city: "Ōtautahi", date: null, when: "2027 entries open",
      course: "Central city loop, Hagley Park", distances: [["Marathon", 42.195], ["Half Marathon", 21.0975], ["10K", 10]], themes: ["harbour", "paper"] },
    { slug: "rotorua", title: "Rotorua Marathon", city: "Rotorua", date: null, when: "2027 entries open",
      course: "One lap of the lake", distances: [["Marathon", 42.195], ["Half Marathon", 21.0975, "half"], ["10K", 10, "10k"]], themes: ["mono", "paper"] },
    { slug: "wellington", title: "Wellington Marathon", city: "Te Whanganui-a-Tara", date: null, when: "2027",
      course: "Out and back along the harbour", distances: [["Marathon", 42.195], ["Half Marathon", 21.0975, "half"], ["10K", 10, "10k"]], themes: ["paper", "harbour"] }
  ];
  // On the calendar but no poster yet.
  var SOON = [
    { title: "Sydney Marathon", date: "2027-05-02", when: "Sun 2 May 2027" },
    { title: "Hawke's Bay Marathon", date: "2027-05-15", when: "Sat 15 May 2027" },
    { title: "Noosa Marathon", date: "2027-05-22", when: "Sat 22 May 2027" }
  ];
  var FROM = "NZ$59";
  function prodUrl(s) { var p = (window.RP_PRODUCTS || {})[s]; return p ? p.url : "/collections/nz-marathons"; }

  // Poster colourways, matching poster.py THEMES.
  var THEME = {
    paper:    { ink: "#1A1A1A", sub: "#6E675C", route: "#E2462B" },
    midnight: { ink: "#F2EEE6", sub: "#8B95A0", route: "#FF7A2F" },
    harbour:  { ink: "#F4F1EA", sub: "#9FB3C4", route: "#F6C744" },
    mono:     { ink: "#111111", sub: "#777777", route: "#111111" }
  };

  // ---------- your time ----------
  var KEY = "rp.you";
  var DEFAULT = { time: "3:45:00", name: "", bib: "", race: "queenstown", sample: true };
  function load() { try { return Object.assign({}, DEFAULT, JSON.parse(localStorage.getItem(KEY) || "{}")); } catch (e) { return Object.assign({}, DEFAULT); } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  var you = load();

  function parseTime(t) {
    var m = String(t || "").trim().replace(/[.\s]+/g, ":").match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
    if (!m) return null;
    var a = +m[1], b = +m[2], c = m[3] == null ? null : +m[3];
    if (b > 59 || (c != null && c > 59)) return null;
    if (c != null) return a * 3600 + b * 60 + c;               // h:mm:ss
    return a < 10 ? a * 3600 + b * 60 : a * 60 + b;           // 3:45 -> 3h45, 48:10 -> 48m10s
  }
  function fmtTime(s) {
    s = Math.max(0, Math.round(s));
    var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    return h ? h + ":" + pad(m) + ":" + pad(x) : m + ":" + pad(x);
  }
  function sampleTime(km) { return Math.round(km * 320 / 60) * 60; }   // 5:20 /km, rounded to the minute
  function fmtPace(s, km) { var p = Math.round(s / km); return Math.floor(p / 60) + ":" + pad(p % 60); }
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function race(slug) { return RACES.find(function (r) { return r.slug === slug; }) || RACES[0]; }
  function daysTo(iso) {
    var d = new Date(iso + "T06:00:00+13:00") - Date.now();
    return Math.ceil(d / 864e5);
  }

  // ---------- live posters ----------
  // <figure class="poster" data-race="queenstown" data-theme="paper" data-distance="Marathon">
  // The base art (map, title, subtitle) is a webp; the personal block is an SVG laid
  // over it in the poster's own millimetre coordinates (426 x 600), so it lines up exactly.
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function personal(theme, v, distLabel, km) {
    // Until they type a time, show a believable one for the distance (3:45 marathon pace).
    var T = THEME[theme] || THEME.paper, secs = v.sample ? sampleTime(km) : parseTime(v.time) || sampleTime(km);
    var who = [];
    if (v.name) who.push(esc(v.name.toUpperCase()));
    if (v.bib) who.push("BIB " + esc(v.bib));
    var y = 475, out = "";
    if (who.length) { out += '<text x="213" y="' + y + '" text-anchor="middle" font-family="Oswald" font-weight="500" font-size="9" letter-spacing="2.4" fill="' + T.ink + '">' + who.join("  ·  ") + "</text>"; y += 10; }
    y += 48;
    out += '<text x="213" y="' + y + '" text-anchor="middle" font-family="Bebas Neue" font-size="62" letter-spacing="2" fill="' + T.route + '">' + fmtTime(secs) + "</text>";
    y += 22;
    out += '<line x1="25" y1="' + (y - 12) + '" x2="401" y2="' + (y - 12) + '" stroke="' + T.sub + '" stroke-opacity="0.35" stroke-width="0.35"/>';
    var stats = [["DISTANCE", km.toFixed(1) + " KM"], ["PACE", fmtPace(secs, km) + " /KM"], ["EVENT", distLabel.toUpperCase()]];
    stats.forEach(function (s, i) {
      var cx = 25 + 376 / 3 * i + 376 / 6;
      out += '<text x="' + cx + '" y="' + (y - 2) + '" text-anchor="middle" font-family="JetBrains Mono" font-size="3.6" letter-spacing="1.2" fill="' + T.sub + '">' + s[0] + "</text>";
      out += '<text x="' + cx + '" y="' + (y + 8) + '" text-anchor="middle" font-family="Oswald" font-weight="500" font-size="8" letter-spacing="0.8" fill="' + T.ink + '">' + esc(s[1]) + "</text>";
    });
    return out;
  }
  function paintPoster(fig) {
    var r = race(fig.dataset.race), theme = fig.dataset.theme || r.themes[0];
    var d = r.distances.find(function (x) { return x.label === fig.dataset.distance || x[0] === fig.dataset.distance; }) || r.distances[0];
    var root = fig.dataset.root || "";
    var src = window.RP_ASSET + "poster-" + r.slug + (d[2] ? "-" + d[2] : "") + "-" + theme + ".webp";
    if (!fig.querySelector("img")) {
      fig.insertAdjacentHTML("afterbegin", '<img src="' + src + '" width="900" height="1268" alt="' +
        esc(r.title + " " + d[0].toLowerCase() + " poster, " + theme + " colourway, with the course map, finish time and pace") + '" loading="' + (fig.dataset.eager ? "eager" : "lazy") + '" decoding="async">' +
        '<svg class="poster__personal" viewBox="0 0 426 600" aria-hidden="true"></svg>');
    } else {
      if (fig.querySelector("img").getAttribute("src") !== src) fig.querySelector("img").src = src;
    }
    fig.querySelector(".poster__personal").innerHTML = personal(theme, you, d[0], d[1]);
  }
  function paintAll() { document.querySelectorAll(".poster").forEach(paintPoster); }

  // ---------- binding: any [data-you] input reads/writes the shared state ----------
  function bind() {
    document.querySelectorAll("[data-you]").forEach(function (el) {
      var k = el.dataset.you;
      if (k === "time" && you.sample) el.value = ""; else el.value = you[k] || "";
      el.addEventListener("input", function () {
        if (k === "time") {
          var ok = el.value.trim() === "" || parseTime(el.value) != null;
          el.setAttribute("aria-invalid", ok ? "false" : "true");
          if (!ok) return;
          you.time = el.value.trim() || DEFAULT.time; you.sample = el.value.trim() === "";
        } else {
          you[k] = k === "race" ? el.value : el.value.slice(0, k === "name" ? 28 : 8);
        }
        save(you); emit();
      });
      // Tidy a typed time into the format that prints, e.g. 3.45 -> 3:45:00
      if (k === "time") el.addEventListener("change", function () {
        var secs = parseTime(el.value); if (secs != null) el.value = fmtTime(secs);
      });
    });
  }
  var listeners = [];
  function emit() {
    paintAll();
    document.querySelectorAll("[data-you-out]").forEach(function (el) {
      var k = el.dataset.youOut, secs = parseTime(you.time);
      if (k === "time") el.textContent = fmtTime(secs);
      if (k === "sample") el.hidden = !you.sample;
    });
    listeners.forEach(function (f) { f(you); });
  }

  // ---------- race ticker (nav) ----------
  function ticker() {
    var el = document.querySelector("[data-ticker]");
    if (!el) return;
    var root = el.dataset.root || "";
    var items = RACES.map(function (r) {
      var n = r.date ? daysTo(r.date) : null;
      var tail = n != null && n > 0 ? n + (n === 1 ? " day" : " days") : r.when;
      return '<a href="' + prodUrl(r.slug) + '"><b>' + esc(r.title) + "</b> " + (r.date ? esc(r.when) + " · " : "") + '<span class="tick__n">' + esc(tail) + "</span></a>";
    }).concat(SOON.map(function (r) {
      return '<span class="tick__soon"><b>' + esc(r.title) + "</b> " + esc(r.when) + " · poster coming</span>";
    }));
    var run = items.join('<i aria-hidden="true">/</i>');
    el.innerHTML = '<div class="tick__run">' + run + '<i aria-hidden="true">/</i></div><div class="tick__run" aria-hidden="true">' + run + '<i>/</i></div>';
    el.querySelectorAll('[aria-hidden="true"] a').forEach(function (a) { a.tabIndex = -1; });
  }

  function brand() {
    document.querySelectorAll("[data-brand]").forEach(function (el) { el.textContent = BRAND; });
    document.title = document.title.replace("Race Posters", BRAND);
  }

  // Mobile menu
  function menu() {
    var b = document.querySelector(".nav__toggle"), n = document.querySelector(".nav");
    if (!b || !n) return;
    b.addEventListener("click", function () { var o = n.classList.toggle("is-open"); b.setAttribute("aria-expanded", o); });
  }

  window.RP = { RACES: RACES, SOON: SOON, FROM: FROM, THEME: THEME, you: function () { return you; }, set: function (k, v) { you[k] = v; save(you); emit(); },
    parseTime: parseTime, fmtTime: fmtTime, sampleTime: sampleTime, fmtPace: fmtPace, race: race, daysTo: daysTo, paintPoster: paintPoster, onChange: function (f) { listeners.push(f); }, emit: emit, esc: esc };

  // Remember the race a link points at, so the builder opens on it even where
  // the query string doesn't survive navigation.
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[data-race-link]');
    if (!a) return;
    var m = [0, a.dataset.raceLink];
    if (m && RACES.some(function (r) { return r.slug === m[1]; })) { you.race = m[1]; save(you); }
  });

  document.addEventListener("DOMContentLoaded", function () { brand(); ticker(); menu(); bind(); emit(); });
})();
